import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { concatMap, skip } from "rxjs/operators";
import { OrderResolver } from '../../resolvers/order.resolver';
import { MsAuthService } from '../../services/ms-auth.service';
import { ITransaction, SaleService } from '../../services/sale.service';
import { Sale } from '../../models/sale.model';

@Component({
  selector: 'order-detail-page',
  templateUrl: './order-detail-page.component.html',
  styleUrls: ['./order-detail-page.component.scss'],
})
export class OrderDetailPageComponent implements OnInit, OnDestroy {
  public order: Sale | undefined;
  public loggedIn$: Observable<boolean>;
  public transactions: ITransaction[] = [];
  private _subscriptions = new Subscription();

  constructor(
    public msAuthService: MsAuthService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _orderResolver: OrderResolver,
    private _saleService: SaleService,
  ) {}

  ngOnInit(): void {
    this.loggedIn$ = this.msAuthService.loggedIn$;
    this._subscriptions.add(
        this.msAuthService.loggedIn$
            .pipe(
                skip(1),
                concatMap((..._) => {
                  this._saleService.resetSales();
                  return this._orderResolver.resolve(this._route.snapshot);
                })
            )
            .subscribe({
              next: (_) => this._fetchResolvedOrder(),
            })
    );

    this._fetchResolvedOrder();
  }

  private _fetchResolvedOrder() {
    const order = this._route.snapshot.data.order;
    if (order && order.length > 0) {
      if (order.length > 1) {
        this._router.navigateByUrl('/order-search');
      }
      if (order.length === 1) {
        this.order = order[0];
        if(this.order.transactions && this.order.transactions.length > 0) {
          this.transactions = this.order.transactions;
        }
      }
    } else {
      this._router.navigateByUrl('/client-search');
    }
    window.scroll(0,0);
  }
  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
